/**
 * Created by danielgw on 5/8/14.
 */
/*
 datePicker [{
 element: #element,
 defaultDate: #date,
 callback: #callback
 }]
 */
define(function (require) {

    var _ = require('underscore');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var TimeFrameManager = {

        createInstance: function (options) {

            var timeFrameManager = {};
            var DateUtility = window.DateUtility || require("utils/DateUtility");
            var maxDaysForTimeframeValue = options.maxDaysForTimeframeValue ? options.maxDaysForTimeframeValue : 30;
            var context = options.context ? options.context : timeFrameManager;
            var DateFormat = {
                Default: "mm/dd/yy",
                ISO8601: "yy-mm-dd",
                Short: "d M, y",
                Medium: "d MM, y",
                Full: "DD, d MM, yy"
            };
            var dateFormatString = options.dateFormat ? DateFormat[options.dateFormat] ? DateFormat[options.dateFormat] : options.dateFormat : DateFormat.Default;
            var datePickerOptions = {
                dateFormat: dateFormatString,
                nextText: agentLEManager.translateLE("LEUIComponents.global.next"),
                prevText: agentLEManager.translateLE("LEUIComponents.global.prev"),
                monthNames: _getFullMonthsArray(),
                dayNames: _getFullDaysArray(),
                dayNamesMin: _getShortDaysArray()
            };
            if (options.setFocusCallback) {
                datePickerOptions.onChangeMonthYear = _.bind(options.setFocusCallback, context, null);
            }
            if (options.minDate) {
                datePickerOptions.minDate = options.minDate;
            }
            if (options.maxDate) {
                datePickerOptions.maxDate = options.maxDate;
            }
            var parentCallback = options.callback;

            var selectedTimeframe = {
                startDate: null,
                endData: null
            };

            function _getFullMonthsArray() {
                var monthIndexArr = _.range(1, 13);
                var arr = _.map(monthIndexArr, function (num) {
                    return agentLEManager.translateLE("LEUIComponents.datePickerComponent.months." + num + ".full");
                });
                return arr;
            }

            function _getFullDaysArray() {
                var dayIndexArr = _.range(1, 8);
                var arr = _.map(dayIndexArr, function (num) {
                    return agentLEManager.translateLE("LEUIComponents.datePickerComponent.days." + num + ".full");
                });
                return arr;
            }

            function _getShortDaysArray() {
                var dayIndexArr = _.range(1, 8);
                var arr = _.map(dayIndexArr, function (num) {
                    return agentLEManager.translateLE("LEUIComponents.datePickerComponent.days." + num + ".short");
                });
                return arr;
            }

            function createDatePickers(element1, element2, startDate, endDate) {

                datePickerOptions.defaultDate = startDate;
                datePickerOptions.onSelect = _.bind(_onStartTriggerChange, timeFrameManager);
                timeFrameManager.startDatePicker = element1.datepicker(datePickerOptions);
                datePickerOptions.defaultDate = endDate;
                datePickerOptions.onSelect = _.bind(_onEndTriggerChange, timeFrameManager);
                timeFrameManager.endDatePicker = element2.datepicker(datePickerOptions);
            }

            function _onStartTriggerChange(dateAsStr, obj) {
                selectedTimeframe.startDate = dateAsStr + " 00:00:00";
                var startDate = DateUtility.strToDateObj(dateAsStr);
                var endDate = timeFrameManager.endDatePicker.datepicker('getDate');
                var diff = DateUtility.getDaysDiff(endDate, startDate) + 1;
                //if the new startDate is later then the endDate then the endDate will be set to it (new startDate) meaning both set to the same date
                if (startDate > endDate) {
                    timeFrameManager.endDatePicker.datepicker('setDate', startDate);
                }
                //if there is maxDaysForTimeframeValue and the number of days between the new startDate and the endDate then the endDate
                //will be set to: startDate +(maxDaysForTimeframeValue-1)
                //+1 because the startDate is not counted in getDaysDiff.
                else if (maxDaysForTimeframeValue && diff > maxDaysForTimeframeValue) {
                    var newDate = new Date(startDate.getTime());
                    newDate.setDate(startDate.getDate() + (maxDaysForTimeframeValue - 1));
                    timeFrameManager.endDatePicker.datepicker('setDate', newDate);
                }
                runCallback(parentCallback, context, getTimeFrameDates());
            }

            function _onEndTriggerChange(dateAsStr) {

                selectedTimeframe.expirationDate = dateAsStr + " 23:59:59";
                var endDate = DateUtility.strToDateObj(dateAsStr);
                var startDate = timeFrameManager.startDatePicker.datepicker('getDate');
                var diff = DateUtility.getDaysDiff(endDate, startDate) + 1;
                //if the new endDate is before startDate then the start date will be set to it (new endDate) meaning both set to the same date
                if (endDate < startDate) {
                    timeFrameManager.startDatePicker.datepicker('setDate', endDate);
                }
                //if there is maxDaysForTimeframeValue and the number of days between the new endDate and the startDate then the startDate
                //will be set to: endDate -(maxDaysForTimeframeValue-1)
                //-1 because the endDate is one more day.
                else if (maxDaysForTimeframeValue &&
                    ((DateUtility.getDaysDiff(endDate, startDate) + 1) > maxDaysForTimeframeValue)) {
                    //-1 because teh startDate is one more day
                    var newDate = new Date(endDate.getTime());
                    newDate.setDate(endDate.getDate() - (maxDaysForTimeframeValue - 1));
                    timeFrameManager.startDatePicker.datepicker('setDate', newDate);
                }
                runCallback(parentCallback, context, getTimeFrameDates());
            }

            function getTimeFrameDates() {
                var startDate = timeFrameManager.startDatePicker.datepicker('getDate');
                var endDate = timeFrameManager.endDatePicker.datepicker('getDate');
                return {startDate: startDate, endDate: endDate};
            }

            //Generic method for running callbacks
            function runCallback(callback, context, data) {
                if (callback && typeof callback === 'function') {
                    try {
                        callback.apply(context.context || context, [data]);
                    } catch (err) {
                        //logger.error("Failed to run callback " + err, context.callingFunction);
                    }
                }
                callback = null;
                data = null;
                context = null;
            }

            createDatePickers(options.datePicker.start.element, options.datePicker.end.element, options.datePicker.start.defaultDate, options.datePicker.end.defaultDate);

            timeFrameManager.onNowSelectedOnDropdown = function (nowString) {
                _onEndTriggerChange(DateUtility.timeObjectToSte(nowString));
            };
            timeFrameManager.updateStartDatePicker = function (newDate) {
                timeFrameManager.startDatePicker.datepicker('setDate', newDate);
            };
            timeFrameManager.updateEndDatePicker = function (newDate) {
                timeFrameManager.endDatePicker.datepicker('setDate', newDate);
            };

            /**
             * Show start date picker
             */
            timeFrameManager.showStartDatePicker = function () {
                timeFrameManager.startDatePicker.show();
            };

            /**
             * Hide start date picker
             */
            timeFrameManager.hideStartDatePicker = function () {
                timeFrameManager.startDatePicker.hide();
            };

            /**
             * Show end date picker
             */
            timeFrameManager.showEndDatePicker = function () {
                timeFrameManager.endDatePicker.show();
            };

            /**
             * Hide end date picker
             */
            timeFrameManager.hideEndDatePicker = function () {
                timeFrameManager.endDatePicker.hide();
            };

            return timeFrameManager;
        }
    };


    return TimeFrameManager;

});
